import { render, staticRenderFns } from "./education.vue?vue&type=template&id=67068f2e&scoped=true&"
var script = {}
import style0 from "./education.vue?vue&type=style&index=0&id=67068f2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67068f2e",
  null
  
)

export default component.exports